/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Tbc native api delegate.
 */
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileAccountSDKNativeApi = exports.MobileAccountSDKNativeCore = void 0;
var events_1 = require("events");
var utils_1 = require("./common/utils");
var interface_1 = require("./interface");
/**
 * Mobile account SDK native core.
 */
var MobileAccountSDKNativeCore = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param {string} name
     */
    function MobileAccountSDKNativeCore(name) {
        this._injectCallbackObject = {};
        this._name = name;
        this._listenerMap = new Map();
        this._callbackFunctionEvent = new events_1.EventEmitter();
        this._lastCallbackFunctionNameId = 0;
        this._nativeWindow = window;
        this._injectCallbackObjectIndex = -1;
    }
    /**
     * Init.
     */
    MobileAccountSDKNativeCore.prototype.init = function () {
        this._native = this._nativeWindow.XLAccountJsBridge;
        if (!this._nativeWindow.injectCallbackObjects_fcd89) {
            this._nativeWindow.injectCallbackObjects_fcd89 = {};
        }
        if (!this._nativeWindow.injectCallbackObjects_fcd89[this._name]) {
            this._nativeWindow.injectCallbackObjects_fcd89[this._name] = [];
        }
        // this._injectCallbackObject = {};
        this._nativeWindow.injectCallbackObjects_fcd89[this._name].push(this._injectCallbackObject);
        this._injectCallbackObjectIndex =
            this._nativeWindow.injectCallbackObjects_fcd89[this._name].length - 1;
    };
    Object.defineProperty(MobileAccountSDKNativeCore.prototype, "name", {
        /** */
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileAccountSDKNativeCore.prototype, "native", {
        /**
         * Get native object.
         */
        get: function () {
            return this._native;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * On.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    MobileAccountSDKNativeCore.prototype.on = function (type, listener) {
        var functionName = this._getNewCallbackFunctionName();
        this._injectCallbackObject[functionName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            listener.apply(void 0, args);
        };
        this._addListener(type, listener, functionName);
        this.native.attachListener(type, this._generateInjectObjectCallbackFunctionName(functionName));
        return this;
    };
    /**
     * Off.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    MobileAccountSDKNativeCore.prototype.off = function (type, listener) {
        var functionName = this._removeListener(type, listener);
        if (typeof functionName === 'string') {
            delete this._injectCallbackObject[functionName];
            this.native.detachListener(type, this._generateInjectObjectCallbackFunctionName(functionName));
        }
        return this;
    };
    /**
     * Check if support CheckFunction.
     * @return {boolean}
     */
    MobileAccountSDKNativeCore.prototype.supportCheckFuncion = function () {
        return typeof this.native.checkFunction === 'function';
    };
    /**
     * Check function.
     * @param {string} functionName
     * @return {Promise<NativeCoreCheckFunctionResponse>}
     */
    MobileAccountSDKNativeCore.prototype.checkFunction = function (functionName) {
        var promise = null;
        var callbackFunctionName = this._getNewCallbackFunctionName();
        promise = this._getNewCallFunctionPromise(callbackFunctionName);
        this.native.checkFunction(functionName, '', this._generateInjectObjectCallbackFunctionName(callbackFunctionName));
        return promise;
    };
    /**
     * Call.
     * @param {string} functionName
     * @param {any[]} args
     * @return {Promise<T>}
     */
    MobileAccountSDKNativeCore.prototype.call = function (functionName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var promise = null;
        var callbackFunctionName = this._getNewCallbackFunctionName();
        promise = this._getNewCallFunctionPromise(callbackFunctionName);
        var params = typeof args !== 'undefined' ? JSON.stringify(args) : '';
        this.native.callFunction(functionName, params, this._generateInjectObjectCallbackFunctionName(callbackFunctionName));
        return promise;
    };
    /**
     * Add listener.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @param {string} functionName
     */
    MobileAccountSDKNativeCore.prototype._addListener = function (type, listener, functionName) {
        var listenerArray;
        if (!this._listenerMap.has(type)) {
            listenerArray = [];
            this._listenerMap.set(type, listenerArray);
        }
        else {
            // 此处必然存在
            listenerArray = this._listenerMap.get(type);
        }
        listenerArray.push({
            functionName: functionName,
            listener: listener,
        });
    };
    /**
     * Remove listener.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {string}
     */
    MobileAccountSDKNativeCore.prototype._removeListener = function (type, listener) {
        var functionName = undefined;
        var listenerArray = this._listenerMap.get(type);
        if (listenerArray) {
            var len = listenerArray.length;
            for (var i = 0; i < len; i++) {
                var item = listenerArray[i];
                if (item) {
                    if (item.listener === listener) {
                        functionName = item.functionName;
                        listenerArray.splice(i, 1);
                        break;
                    }
                }
            }
        }
        return functionName;
    };
    /**
     * Get new callback function name.
     * @return {string}
     */
    MobileAccountSDKNativeCore.prototype._getNewCallbackFunctionName = function () {
        var newFunctionName = '';
        do {
            var newId = this._lastCallbackFunctionNameId++;
            newFunctionName = 'callback' + newId.toString();
        } while (this._injectCallbackObject[newFunctionName] !== undefined);
        return newFunctionName;
    };
    /**
     * Generate inject object callback function name.
     * @param {string} callbackFunctionName
     * @return {string}
     */
    MobileAccountSDKNativeCore.prototype._generateInjectObjectCallbackFunctionName = function (callbackFunctionName) {
        return "window.injectCallbackObjects_fcd89['" + this._name + "'][" + this._injectCallbackObjectIndex + "]." + callbackFunctionName;
    };
    /**
     * Remove callback function name.
     * @param {string} functionName
     */
    MobileAccountSDKNativeCore.prototype._removeCallbackFunctionName = function (functionName) {
        delete this._injectCallbackObject[functionName];
    };
    /**
     * Get new callback function promise.
     * @param {string} callbackFunctionName
     * @return {Promise<any>}
     */
    MobileAccountSDKNativeCore.prototype._getNewCallFunctionPromise = function (callbackFunctionName) {
        var _this = this;
        this._injectCallbackObject[callbackFunctionName] = function (result) {
            _this._callbackFunctionEvent.emit(callbackFunctionName, result);
            _this._removeCallbackFunctionName(callbackFunctionName);
        };
        var promise = new Promise(function (resolve, reject) {
            _this._callbackFunctionEvent.once(callbackFunctionName, function (result) {
                if (result && result.error) {
                    reject(result);
                }
                else {
                    resolve(result);
                }
            });
        });
        return promise;
    };
    return MobileAccountSDKNativeCore;
}());
exports.MobileAccountSDKNativeCore = MobileAccountSDKNativeCore;
/**
 * Mobile account SDK native api.
 */
var MobileAccountSDKNativeApi = /** @class */ (function (_super) {
    __extends(MobileAccountSDKNativeApi, _super);
    /**
     * constructor
     *
     * @param {string} name
     */
    function MobileAccountSDKNativeApi(name) {
        var _this = _super.call(this) || this;
        _this._name = name;
        _this._nativeCore = new MobileAccountSDKNativeCore(name);
        return _this;
    }
    Object.defineProperty(MobileAccountSDKNativeApi.prototype, "name", {
        /** */
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileAccountSDKNativeApi.prototype, "nativeCore", {
        /**
         * Get native core.
         */
        get: function () {
            return this._nativeCore;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Init.
     */
    MobileAccountSDKNativeApi.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.nativeCore.init();
                this.nativeCore.on('login', function () {
                    _this.emit('login');
                });
                this.nativeCore.on('logout', function () {
                    _this.emit('logout');
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * 获取app信息。
     */
    MobileAccountSDKNativeApi.prototype.getAppInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, deviceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nativeCore.call('getAppInfo')];
                    case 1:
                        appInfo = _a.sent();
                        if (appInfo.deviceId === undefined || appInfo.deviceId === null) {
                            deviceId = utils_1.deviceSign2DeviceId(appInfo.deviceSign);
                            if (deviceId) {
                                appInfo.deviceId = deviceId;
                            }
                        }
                        return [2 /*return*/, appInfo];
                }
            });
        });
    };
    /**
     * 获取 session user info。
     */
    MobileAccountSDKNativeApi.prototype.getSessionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('getSessionUserInfo')];
            });
        });
    };
    /**
     * 展示登录窗口。
     */
    MobileAccountSDKNativeApi.prototype.showLoginWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('showLoginWindow')];
            });
        });
    };
    /**
     * 获取 access token。
     */
    MobileAccountSDKNativeApi.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('getAccessToken')];
            });
        });
    };
    /**
     * 传递登录信息给客户端，登录或退出完成后函数才返回。
     *
     * @param {CredentialsLoginInfo} credentialsLoginInfo
     * @throws {ResponseError} 参数错误则error为invalid_argument。
     * credentialsLoginInfo.credentials不为null，若端已登录则error为already_exists。
     * @return {Promise<void>}
     */
    MobileAccountSDKNativeApi.prototype.setCredentialsLoginInfo = function (credentialsLoginInfo) {
        return this.nativeCore.call('setCredentialsLoginInfo', credentialsLoginInfo);
    };
    return MobileAccountSDKNativeApi;
}(interface_1.NativeApi));
exports.MobileAccountSDKNativeApi = MobileAccountSDKNativeApi;
//# sourceMappingURL=account-mobile-sdk-native-api.js.map